
const currencyStyle = {
    noWrap: {
        whiteSpace: "nowrap",
    },
};

export default currencyStyle;
